/* eslint-disable */
// import axios from "axios";
// import App from '../../App.vue';
import Vue from "vue";

export default{
    state: {
        center_map:{},
        markers:[]
    },
    
    mutations: {
        setCenterMap(state,value){
            state.center_map=value;
        },
        setMarkers(state,value){
            state.markers=value;
        }
    },

    getters:{
        getCenterMap(state){
            return state.center_map;
        },
        getMarkers(state){
            return state.markers;
        }        
    },
    
    actions: {
       SET_CENTER_MAP:({commit},value)=>{
           commit('setCenterMap',value);
       },
       SET_MARKERS:({commit},value)=>{
        commit('setMarkers',value);
    }
    },
}